import { createSelector } from 'reselect';
import { MyBoardView } from './view/MyBoardView';
import { getMyBoardState } from './selector/getMyBoardState';
import { MyBuilderActionState } from '@Stores/builder/MyBuilderState';

export const MyBoardPresenter = createSelector(
  [getMyBoardState],
  (myBoardState): MyBoardView => {
    return new MyBoardView({
      createArmyList:
        myBoardState?.entity === MyBuilderActionState.ArmyListCreation,
      createArsenalArmy:
        myBoardState?.entity === MyBuilderActionState.ArsenalArmyCreation,
      createForlder:
        myBoardState?.entity === MyBuilderActionState.FolderCreation,
      formatArmyList:
        myBoardState?.entity === MyBuilderActionState.ArmyListFormat,
      createContest:
        myBoardState?.entity === MyBuilderActionState.ContestCreation,
    });
  },
);
